export default {
  name: 'LoadMore',
  template: `
<div class="load-more__navigation">
  <h4>
    {{ $t('results') }}
    <span class="load-more-loaded">{{ cardsLoaded <= allCards ? cardsLoaded : allCards }}</span> /
    <span class="load-more-total">{{ allCards }}</span>
  </h4>
  <hr>
  <button v-if="cardsLoaded < allCards" class="show-more" @click="$emit('expand')">
    {{ $t('loadMore') }}
    <i class="icon-caret-down"></i>
  </button>
</div>
  `,
  props: { cardsLoaded: Number, allCards: Number },
  emits: ['expand'],
}
